// Plan currency comes from the same server catalogue used by checkout.
// Prices read the way the landings print them: "$15", "£15", never "US$15".
export function formatPlanPrice(plan, config) {
  const currency = plan && plan.features && plan.features.currency || config && config.currency || 'usd';
  const options = {
    style: 'currency', currency: String(currency).toUpperCase(),
    minimumFractionDigits: 0, maximumFractionDigits: 2
  };
  const amount = Number(plan.price_monthly || 0);
  try {
    return new Intl.NumberFormat('en-GB', Object.assign({ currencyDisplay: 'narrowSymbol' }, options)).format(amount);
  } catch (e) {
    // Engines without narrowSymbol keep the standard symbol.
    return new Intl.NumberFormat('en-GB', options).format(amount);
  }
}

// A free plan costs nothing "forever" rather than "$0 / month".
export function isFreePlan(plan) {
  if (!plan) return false;
  const zero = value => value !== null && value !== undefined && value !== '' && Number(value) === 0;
  return String(plan.name || '').toLowerCase() === 'free' || zero(plan.price_monthly) || zero(plan.price);
}
